defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/PlayCard',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/PlayCountdown'
  ],
  function (m, CtaButton, PlayCountdown) {
    const gameLogoNames = {
      eurojackpot: 'icon-eurojackpot_logo_bg_yellow',
      lottosaturday: 'icon-lotto_logo_red',
      vikinglotto: 'icon-vikinglotto_logo_blue'
    };
    const numbergamesIconsPath = '/Components/DanskeSpil/Domain/NumberGamePackage/Graphics/SpriteSheets/PackageCommonIcons.svg#';
    const playTogetherIconsPath = '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#';

    var PlayCard = {
      controller: function ({ controller, play }) {
        Object.assign(this, controller);
        this.cardDictionary = this.rootDictionary.get.bind({ prefix: 'OfferedCard/' });
        this.asSubscription = Boolean(play.subscriptionGroupGameId);

        let playParams = `?klubId=${this.clubId()}`;
        if (this.asSubscription) {
          playParams += `&subscriptionGroupGameId=${play.subscriptionGroupGameId}`;
        } else {
          playParams += `&spilId=${play.groupPlayId}`;
        }

        this.viewCouponLink = `${this.navigationPaths.playCouponPage}${playParams}`;
        this.buyInLink = `${this.navigationPaths.buyInPage}${playParams}`;

        this.gameName = play.game.toLowerCase();
        this.isOffer = play.mySummary.stakeAmount === 0;
        this.jackpots = {
          ...this.settings.jackpots,
          lottosaturday: this.settings.jackpots.lotto
        };
        this.playPlayersCount = play.playerFundingSummaries.length;
        this.jackpotHeadline = this.cardDictionary('PoolSize', { poolSize: this.jackpots[this.gameName] });

        this.rowsCountContent = (() => {
          let rowsCountPath = 'RowsCount';
          let rowsCount = play.playerFundingSummaries.reduce((accumulator, play) => {
            return accumulator + play.rowCount;
          }, 0);

          if (rowsCount === 1) {
            rowsCountPath += 'Singular';
          }

          if (rowsCount === 0 && play.depositType === 'FixedRowCount') {
            rowsCount = play.fixedRowCount;
          }

          return this.cardDictionary(rowsCountPath, { count: rowsCount });
        })();

        this.playersCountContent = (() => {
          var playersCountPath = 'PlayersCount';
          if (this.playPlayersCount === 0) {
            playersCountPath += 'NoPlayers';
          }
          if (this.playPlayersCount === 1) {
            playersCountPath += 'Singular';
          }

          return this.cardDictionary(playersCountPath, { count: this.playPlayersCount });
        })();
      },
      view: function (controller, { play }) {
        const cardCtaButton = () => {
          if (controller.isOffer) {
            return CtaButton({
              text: controller.cardDictionary('PlayNow'),
              href: controller.buyInLink,
              options: ['primary', 'small']
            });
          }

          const countdownContent = PlayCountdown({
            timestamp: play.nextDraw,
            countdownDictionary: controller.cardDictionary
          });

          return CtaButton({
            text: countdownContent,
            href: controller.viewCouponLink,
            options: ['small']
          });
        };

        const detailItem = (icon, text) => {
          return m('.play-together-play-card__detail-item', [
            m('svg.play-together-play-card__detail-item-icon',
              m('use', { href: `${playTogetherIconsPath}${icon}` })
            ),
            m('.play-together-play-card__detail-item-text', text)
          ]);
        };

        return m('.play-together-play-card', [
          m('.play-together-play-card__inner-wrapper', {
            class: controller.asSubscription ? 'play-together-play-card__inner-wrapper--subscription' : '',
            onclick: () => window.location = controller.viewCouponLink
          }, [
            controller.asSubscription ? m('svg.play-together-play-card__subscription-icon', m('use', {
              href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#spilSammen-plus_logo'
            })) : null,
            m('svg.play-together-play-card__information-icon', m('use', { href: `${playTogetherIconsPath}information` })),
            m('.play-together-play-card__game-logo-wrapper',
              m('svg.play-together-play-card__game-logo-icon', {
                class: `play-together-play-card__game-logo-icon--${controller.gameName}`
              }, [
                m('use', { href: `${numbergamesIconsPath}${gameLogoNames[controller.gameName]}` })
              ])
            ),
            m('.play-together-play-card__compact-details',
              detailItem('players', controller.playersCountContent)
            ),
            m('.play-together-play-card__headline', controller.jackpotHeadline),
            m('.play-together-play-card__buttons', cardCtaButton()),
            m('.play-together-play-card__footer', [
              // players count:
              detailItem('players', controller.playersCountContent),
              // rows count:
              controller.playPlayersCount > 0 ? detailItem('card_with_rows_tilted', controller.rowsCountContent) : null,
              //  deposit type:
              detailItem('coins', controller.cardDictionary(`DepositType${play.depositType}`))
            ])
          ])
        ]);
      }
    };

    return PlayCard;
  });
